import { useSetAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import { FC, useEffect } from 'react';
import { useSeedSampleCompanies } from '../../../components/FrostedGate/useSeedSampleCompanies';
import { Loader } from '../../../components/Loader/Loader';
import { DataPointPeriodicity } from '../../../schemas/CompanyPeriodRequest.schema';
import { kpiTemplatesListStateJ } from '../../../services/state/KPI/KPITemplatesStateJ';
import { CompanyPeriodRequestManageV2 } from './CompanyPeriodRequestManageV2';
import {
  PREVIEW_COMPANIES,
  PREVIEW_PERIODS,
  previewRequestStats,
  previewRequests,
} from './company-period-request.fixtures';
import { ALL_PERIODS, getV2CompanyPeriodRequestStatuses } from './manage-request-utils';

const requests = previewRequests(PREVIEW_COMPANIES);
const requestStats = previewRequestStats(requests);
const allStatuses = getV2CompanyPeriodRequestStatuses();
const ignore = () => undefined;

/** Sample-data stand-in for the Manage Requests page while the KPI module is frosted. */
export const CompanyPeriodRequestManagePreview: FC = () => {
  // Company cells and the grid schema read the company and template stores; seeding both
  // first keeps the frosted page request-free, and both go back to normal on unmount.
  const seeded = useSeedSampleCompanies(PREVIEW_COMPANIES);
  const setTemplates = useSetAtom(kpiTemplatesListStateJ);

  useEffect(() => {
    setTemplates([]);
    return () => setTemplates(RESET);
  }, [setTemplates]);

  if (!seeded) {
    return <Loader />;
  }

  return (
    <CompanyPeriodRequestManageV2
      allStatuses={allStatuses}
      requestStats={requestStats}
      availablePeriods={PREVIEW_PERIODS}
      requests={requests}
      selectedFrequency={DataPointPeriodicity.quarter}
      onFrequencyChange={ignore}
      selectedPeriod={ALL_PERIODS}
      onPeriodChange={ignore}
    />
  );
};
